import { MouseEvent, useState } from 'react'

import { ACTION_CODE, EVENT_CODE } from '@constants'
import {
  ActionRow,
  ConfiguredColumn,
  GETAllTooltipLines,
  GETVariableDTO,
  ObjectDataRecord,
  Position,
} from '@types'

import { useExecuteActions } from './useExecuteActions'

type TooltipData = {
  items: GETAllTooltipLines
  metaData: Record<string, any>
  width: number | null
  loading?: boolean
} | null

export const useTooltip = () => {
  const [position, setPosition] = useState<Position | null>(null)
  const [data, setData] = useState<TooltipData>(null)

  const { executeActions } = useExecuteActions()

  const handleOpenTooltip = async (
    event: MouseEvent<HTMLElement>,
    data: {
      srcObj?: ObjectDataRecord
      action: ActionRow
      column?: ConfiguredColumn
    }
  ) => {
    const { action, column, srcObj } = data

    let staticVariables: Record<string, GETVariableDTO> = {}

    if (action.tooltip?.actions?.length) {
      setPosition({ x: event.clientX, y: event.clientY })
      setData({
        items: [],
        metaData: {
          srcObj,
          variables: action.tooltip?.variables,
          column,
        },
        width: action.tooltip?.width ?? null,
        loading: true,
      })

      const actionsData = await executeActions({
        actions: action.tooltip?.actions,
        isUseCacheCommandRequest: true,
        eventCode: EVENT_CODE.ON_INIT_TOOLTIP,
        srcObj,
      })

      actionsData.forEach(item => {
        if (item.status === 'fulfilled') {
          if (item.value?.actionCode === ACTION_CODE.SET_VARIABLE_VALUE) {
            staticVariables = { ...staticVariables, ...item.value.value }
          }
        }
      })
    }

    const items = action?.tooltip?.isJson
      ? JSON.parse(action?.tooltip?.jsonValue)
      : action?.tooltip?.lines

    if (!action.tooltip?.actions?.length) {
      setPosition({ x: event.clientX, y: event.clientY })
    }

    setData({
      items,
      metaData: {
        srcObj: {
          ...srcObj,
          staticVariables,
        },
        variables: action.tooltip?.variables,
        column,
      },
      width: action.tooltip?.width ?? null,
    })
  }

  const handleCloseTooltip = () => {
    setPosition(null)
  }

  return {
    tooltipPosition: position,
    tooltipData: data,
    handleOpenTooltip,
    handleCloseTooltip,
  }
}
